import { useSelectorToStore } from '@hooks/reduxHooks';
import styled from 'styled-components';
import Item from '@models/Item';
import FreeLessonFrame from '@cont/FreeLesson/FreeLessonFrame';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  z-index: 3;
`;

const EmbedPage = () => {
  const mapStateToProps = ({ others, auth }) => ({
    postData: others.postData,
    user: auth.me || {}
  });
  const { postData, user } = useSelectorToStore(mapStateToProps);
  const post = postData ? Item.getEntityData(postData) : null;
  return post ? (
    <Wrapper>
      <FreeLessonFrame lessonDetails={post} user={user} isEmbed />
    </Wrapper>
  ) : (
    <Wrapper />
  );
};

export default EmbedPage;
